<template>
    <Content>
        <div class="section-product-item">
            <figure>
                <picture>
                    <source v-if="$productImageSrcset(product.image_main)" type="image/webp" :srcset="$productImageSrcset(product.image_main)" sizes="200px">
                    <img
                        :src="product.image_main"
                        :alt="product.pro_name_site"
                        loading="lazy"
                    />
                </picture>
            </figure>

            <ContentDetailed>
                <div>
                    <h3 @click="goToProductPage(product, keyProduct)">
                        {{ product.pro_name_site }}
                    </h3>

                    <div
                        v-if="!hidePrice && !product.price_on_request"
                        class="product-to-buy-together-price"
                    >
                        <span
                            v-if="showProductOldPrice"
                            class="old-banner-price"
                        >
                            {{ productOldPrice }}
                        </span>
                        <span>{{ productPrice }}</span>
                    </div>
                </div>

                <template v-for="(listItem, key) in list">
                    <ContentGrid v-if="listItem.length" :key="key">
                        <label v-if="title[key] || color.direction == key">
                            <strong>
                                {{
                                    color.direction == key
                                        ? color.type
                                        : title[key]
                                }}:
                            </strong>
                            <span
                                v-if="color.direction == key"
                                class="color-selected"
                            >
                                {{ color.name }}
                            </span>
                        </label>
                        <ul>
                            <template v-for="(item, index) in listItem">
                                <ContentGridItem
                                    :key="`${key}-${index}`"
                                    :class="[
                                        item.is_color && 'item-grid-color',
                                        item.active && 'active',
                                        disabledItemGrid(item, key) &&
                                            'disabled-item-grid'
                                    ]"
                                    @click="handleSelect(item, key)"
                                >
                                    <span v-if="!item.is_color">
                                        {{ item.grid_abbreviation }}
                                    </span>
                                    <ProductGridColor
                                        v-else
                                        :color="item"
                                        :disabledColor="
                                            disabledItemGrid(item, key)
                                        "
                                    />
                                </ContentGridItem>
                            </template>
                        </ul>
                    </ContentGrid>
                </template>
            </ContentDetailed>
            <div
                v-if="keyProduct > 0"
                @click="product.selected_tie_sale = !product.selected_tie_sale"
                class="check-item"
            >
                <i v-if="product.selected_tie_sale" class="fas fa-check"></i>
            </div>
        </div>
    </Content>
</template>

<script>
import {
    Content,
    ContentDetailed,
    ContentGrid,
    ContentGridItem
} from "./style";
import Currency from "../../../helpers/parseCurrency";
import { mapGetters, mapState } from "vuex";
import ProductGridColor from "../ProductGridColor";

export default {
    name: "ProductsToBuyTogetherItem",
    props: {
        product: {
            required: true
        },
        keyProduct: {
            required: true
        }
    },
    components: {
        Content,
        ContentDetailed,
        ContentGrid,
        ContentGridItem,
        ProductGridColor
    },
    data() {
        return {
            currency: Currency,
            list: {
                column: [],
                row: []
            },
            title: {
                column: null,
                row: null
            },
            color: {
                type: null,
                name: null,
                direction: null
            },
            keyItemsGrid: 0
        };
    },
    mounted() {
        this.setGrid();
    },
    methods: {
        goToProductPage(product, key) {
            if (key > 0) {
                window.location.href = product.url_pro;
            }
        },
        handleSelect(item, type) {
            this.list.row.map(e => (e.active = false));
            this.list[type].map(e => (e.active = false));
            // this.color = {
            //     type: null,
            //     name: null,
            //     direction: null
            // };
            item.active = true;
            if (type == "column") {
                let itemGrid =
                    ((!this.title?.column && !this.title?.row) ||
                        item?.single_purchase_allowed) &&
                    (item.quantity >= this.minimumQuantity ||
                        this.product.sell_out_of_stock)
                        ? item
                        : null;

                this.setPriceProduct(
                    itemGrid?.grid_price_site ?? this.product.bkp_pro_price_site
                );

                this.title.row = item?.row
                    ? item.row[0].grid_group_name.toLowerCase()
                    : null;
                this.list.row = item?.row
                    ? item.row.map(e => {
                          e.grid_abbreviation = e.grid_abbreviation.replace(
                              `${item.grid_abbreviation} / `,
                              ""
                          );
                          return e;
                      })
                    : [];
                if (item.is_size) {
                    this.color = {
                        type: null,
                        name: null,
                        direction: null
                    };
                }
            } else {
                this.setPriceProduct(item.grid_price_site);
            }
            if (item.is_color) {
                this.color.type =
                    item.type == "COLOR"
                        ? "Cor"
                        : item.type == "ESTAMPA"
                        ? "Estampa"
                        : "";
                this.color.name = item.color_name.toLowerCase();
                this.color.direction = type;
            }
        },
        disabledItemGrid(item_grid, direction) {
            let direction_inverse = direction == "column" ? "row" : "column";
            let min =
                this.product?.quantity_conversion_factor >
                this.product.minimum_sale_quantity
                    ? this.product.quantity_conversion_factor
                    : this.product.minimum_sale_quantity;
            return (
                !this.product.sell_out_of_stock &&
                (item_grid.quantity < 1 || min > item_grid.quantity) &&
                (!item_grid[direction_inverse] ||
                    !item_grid[direction_inverse].length ||
                    item_grid[direction_inverse].every(
                        el => el.quantity < 1 || min > el.quantity
                    ))
            );
        },
        setGrid() {
            this.product.bkp_pro_price_site = this.product.pro_price_site;
            this.product.reset_items_grid = false;
            if (this.product?.items_grid_columns_and_rows) {
                if (this.product.items_grid_columns_and_rows?.column?.length) {
                    this.title.column = this.product.items_grid_columns_and_rows.column[0]?.grid_group_name?.toLowerCase();
                    this.list.column = this.product.items_grid_columns_and_rows.column
                        .map(col => {
                            if (!col?.grid_abbreviation) {
                                col.grid_abbreviation = col.grid_description;
                            } else if (
                                col.grid_abbreviation &&
                                this.title?.column
                            ) {
                                col.grid_abbreviation = col?.grid_abbreviation?.split(
                                    " /"
                                )[0];
                            }
                            if (col?.row) {
                                col.row.sort(
                                    (a, b) =>
                                        a.priority_option - b.priority_option
                                );
                            }
                            return col;
                        })
                        .sort((a, b) => a.priority_option - b.priority_option);
                    this.title.row = null;
                    this.list.row = [];
                } else if (this.product.items_grid_columns_and_rows?.row?.length) {
                    this.title.row = this.product.items_grid_columns_and_rows.row[0]?.grid_group_name?.toLowerCase();
                    this.list.row = this.product.items_grid_columns_and_rows.row.sort(
                        (a, b) => a.priority_option - b.priority_option
                    );
                    this.title.column = null;
                    this.list.column = [];
                }
            }
        },
        setPriceProduct(grid_price) {
            let percentage_discount = 0;
            let percentage_discount_by_user = this.product.percentage_discount_by_user;
            let commercial_discount_by_user = this.product.commercial_discount_by_user
            let financial_discount_by_user = this.product.financial_discount_by_user
            let shipping_increase_user = this.product.shipping_increase_user
            let price_to = this.product.price_to;
            let pro_price_site = this.product.pro_price_site;
            let pro_sale = this.product.pro_sale;


            if (price_to > 0) {
                percentage_discount = 100 - (price_to * 100) / pro_price_site;
            }

            if (!pro_sale) {
                percentage_discount_by_user = grid_price - (grid_price * percentage_discount_by_user) / 100;
                commercial_discount_by_user = percentage_discount_by_user - (percentage_discount_by_user * commercial_discount_by_user / 100 );
                financial_discount_by_user = commercial_discount_by_user - (commercial_discount_by_user * financial_discount_by_user / 100);
                pro_price_site = financial_discount_by_user + (financial_discount_by_user * shipping_increase_user) / 100;
            }
            else {
                percentage_discount_by_user = grid_price - (grid_price * percentage_discount_by_user) / 100;
                pro_price_site = percentage_discount_by_user + (percentage_discount_by_user * shipping_increase_user) / 100;
            }

            if (percentage_discount > 0) {
                price_to =
                    pro_price_site -
                    (pro_price_site * percentage_discount) / 100;
            }

            this.product.pro_price_site = pro_price_site;
            this.product.price_to = price_to;
        }
    },
    watch: {
        product: {
            handler(product) {
                if (
                    product.reset_items_grid &&
                    (product?.items_grid_columns_and_rows?.column?.length ||
                        product?.items_grid_columns_and_rows?.row?.length)
                ) {
                    this.setGrid();
                }
            },
            deep: true
        }
    },
    computed: {
        ...mapState("products", [
            "product_pro_price_site_bkp_discount_closed_box"
        ]),
        ...mapGetters("company", ["hidePriceNotLoggedUser"]),
        isLogged() {
            return this.$root.$children[0].$attrs.logged;
        },
        hidePrice() {
            return !this.hidePriceNotLoggedUser
                ? false
                : this.hidePriceNotLoggedUser && !this.isLogged
                ? true
                : false;
        },
        showProductOldPrice() {
            return (
                this.product.price_to ||
                (this.product.from_price_site &&
                    this.product.pro_price_site &&
                    this.product.grid_price_site > this.product.from_price_site)
            );

        },
        productOldPrice() {
            return this.currency.money(
                this.product.pro_price_site || this.product.from_price_site
            );
        },
        productPrice() {
            return this.currency.money(
                !this.product.price_to
                    ? this.product.pro_price_site
                    : this.product.price_to
            );
        }
    }
};
</script>
